(() => {
  if (customElements.get('cart-drawer-upsell-items')) {
    return;
  }

  class CartDrawerUpsellItems extends HTMLElement {
    constructor() {
      super();
      
      this.slider = this.querySelector('[data-slider]');
      
      this.initialLoad = true;
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:unload', e => {
          if (e.target.contains(this)) {
            this.slider.destroy(true);
          }
        });
      }
    }

    connectedCallback() {
      if (!this.slider) return;
      
      this.slider = new Swiper(this.slider, {
        speed: 400,
        autoplay: {
          delay: 4000
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        }
      });
    }
  }

  customElements.define('cart-drawer-upsell-items', CartDrawerUpsellItems);
})();
